import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: "#000000",
            secondary: "#cb0246",
            third: "#ffd08f", 
            accent: "#3F51B5", 
          },
        },
      },
});
